import React, { useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import TimelinePostList from "components/TimelinePostList";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import TimelineCreatePost from "components/TimelineCreatePost";
import { useSelector, useDispatch } from "react-redux";
import { TimelineContext } from "store/contexts/timelineContext";
import * as timelineActions from "reteamStore/actions";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import SearchingOptions from "components/SearchingOptions";
import * as moment from "moment";
import PostModal from "components/TimelinePostList/TimelinePost/PostModal";
import { onMessageListener } from "services/FirebaseService";
import FirebaseDataModal from "./FirebaseDataModal";

export default () => {
  const dispatch = useDispatch();
  const { sortData, allTimelinePost, filters, teamId } = useTeamActionContext();
  const [showModal, setShowModal] = useState(false);
  const [firebaseData, setFirebaseData] = useState(null);

  const { timeline, total, page, isLoading } = useSelector(
    (state) => state.timelineReducer
  );
  const [isOpen, setOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [hide, setHide] = useState(false);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const getNextPageData = () => {
    allTimelinePost(page + 1);
    dispatch(timelineActions.pageIncreament());
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <h4 style={{ width: "80%" }}>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  const updatePost = (post) => {
    dispatch(timelineActions.updatePost(post));
  };

  const deletePost = (post) => {
    dispatch(timelineActions.deletePost(post));
    closeModal();
  };

  const createPost = (post) => {
    if (!post) {
      return;
    }

    var result = checkFilter(post);

    var result2 = checkSort(post);

    if (result && result2) {
      dispatch(timelineActions.createPost(post));
    }
  };

  const selectPost = (post) => {
    setSelectedPost(post);
  };

  const closeModal = () => {
    if (hide) setHide(false);
    setSelectedPost(false);
    setShowModal(false); // Hide the modal when closed
  };

  const checkFilter = (post) => {
    if (!filters) {
      return true;
    }

    var postTypeExist =
      filters.type_id.length > 0
        ? postExistInFilter(post.type_id, "type_id")
        : -1;

    var memberExist =
      filters.selectMembers.length > 0
        ? checkIfUserExist("selectMembers", post.user)
        : -1;

    var dateToExist = filters.date_to
      ? dateExist("date_to", post)
      : filters.date_from
      ? dateExist("date_from", post)
      : null;

    var taggedUsers =
      filters.taggedMembers.length > 0
        ? filterTwoArray(filters.taggedMembers, post.data.tagged_users)
        : -1;

    if (
      postTypeExist === false ||
      memberExist === false ||
      dateToExist === false
    ) {
      return false;
    }

    if (
      postTypeExist === -1 &&
      (memberExist === false || dateToExist === false)
    ) {
      return false;
    }

    if (
      memberExist === -1 &&
      (postTypeExist === false || dateToExist === false)
    ) {
      return false;
    }

    if (
      dateToExist === null &&
      (postTypeExist === false || memberExist === false)
    ) {
      return false;
    }

    if (
      filters.type_id.includes(8) &&
      taggedUsers === false &&
      ([false, -1].includes(dateToExist) || [false, -1].includes(memberExist))
    ) {
      return false;
    }

    return true;
  };

  const checkIfUserExist = (value, user) => {
    var result = filters[value].some((member) => member.id === user.id);

    return result;
  };

  const filterTwoArray = (arr1, arr2) => {
    var result = arr2.map((el) => {
      return arr1.some((ele) => {
        if (ele.id === el.id) {
          return true;
        }
        return false;
      });
    });

    var finalResult = result.includes(true);
    return finalResult;
  };

  const dateExist = (filterDate, post) => {
    if (
      filterDate === "date_to" &&
      moment(filters[filterDate]).format("YYYY-MM-DD") ===
        moment(post.created_at).format("YYYY-MM-DD")
    ) {
      return true;
    }

    if (filterDate === "date_from") {
      return true;
    }

    return false;
  };

  const postExistInFilter = (id, value) => {
    switch (filters[value].includes(id)) {
      case true:
        return true;

      default:
        return false;
    }
  };

  const checkSort = (post) => {
    if (!sortData) {
      return true;
    }

    if (
      ["Engagement", "Reaction", "Oldest"].includes(sortData.orderName) &&
      total <= 29
    ) {
      dispatch(timelineActions.createPostEnd(post));
      return false;
    }

    if (
      ["Engagement", "Reaction", "Oldest"].includes(sortData.orderName) &&
      total >= 30
    ) {
      return false;
    }

    return true;
  };

  onMessageListener()
    .then((payload) => {
      console.log(payload);
      if (payload.data.type === "update.user.points") {
        setFirebaseData({
          maxPoints: payload.data.user_rank.max_points,
          minPoints: payload.data.user_rank.min_points,
          points: payload.data.user_rank.points,
          maxPointsTeam: payload.data.user_rank_in_team.max_points,
          minPointsTeam: payload.data.user_rank_in_team.min_points,
          pointsTeam: payload.data.user_rank_in_team.points,
        });
        setShowModal(true);
      }
    })
    .catch((err) => console.log("failed: ", err));

  console.log(showModal);

  return (
    <TimelineContext.Provider
      value={{
        createPost,
        updatePost,
        deletePost,
        teamId,
        selectPost,
        setHide,
        selectedPost,
      }}
    >
      {showModal && (
        <div className="modal-container">
          <FirebaseDataModal
            showModal={showModal}
            toggleModal={closeModal}
            firebaseData={firebaseData}
          />
        </div>
      )}

      <div
        className="createContentContainer write-post pb-4"
        style={{ top: isOpen ? "0px" : "-100px" }}
      >
        <TimelineCreatePost setOpen={setOpen} isOpen={isOpen} />
      </div>
      <div>
        <SearchingOptions />
      </div>
      <div className="mainRootContainer">
        <InfiniteScroll
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          dataLength={total ?? 0}
          next={getNextPageData}
          hasMore={timeline.length !== total}
          loader={LoadingContainer}
          scrollableTarget="main-panel-right"
          endMessage={
            <p style={{ textAlign: "center" }}>
              {total > 0 && <b>Keep Engaging! </b>}
            </p>
          }
        >
          <TimelinePostList posts={timeline} total={total} />
        </InfiniteScroll>
      </div>
      <PostModal
        hide={hide}
        post={selectedPost}
        open={selectedPost}
        close={closeModal}
      />
    </TimelineContext.Provider>
  );
};
